import React from 'react';
import { Form, Input, Row, Col, Select, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const AddDeviceModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { TextArea } = Input;

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
    props.close();
  };

  return (
    <Modal
      title={t("DevicePage.addDevice")}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.macAddress")}
              name="macAddress"
              rules={[{ required: true, message: t("DevicePage.deviceModal.macAddressRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.name")}
              name="deviceName"
              rules={[{ required: true, message: t("DevicePage.deviceModal.nameRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.password")}
              name="password"
              rules={[{ required: true, message: t("DevicePage.deviceModal.passwordRequired") }]}
            >
              <Input type="password" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionX")}
              name="deviceposX"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionXRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionY")}
              name="deviceposY"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionYRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionZ")}
              name="deviceposZ"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionZRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationX")}
              name="devicerotX"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationXRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationY")}
              name="devicerotY"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationYRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationZ")}
              name="devicerotZ"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationZRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.location")}
              name="location"
              rules={[{ required: true, message: t("DevicePage.deviceModal.locationRequired") }]}
            >
              <Select options={props.suggestions} placeholder={t("DevicePage.deviceModal.locationPlaceholder")} />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.type")}
              name="devicetype"
              rules={[{ required: true, message: t("DevicePage.deviceModal.typeRequired") }]}
            >
              <Select>
                <Select.Option value={1}>{t("deviceType.cliff")}</Select.Option>
                <Select.Option value={2}>{t("deviceType.ceil")}</Select.Option>
                <Select.Option value={3}>{t("deviceType.vibs")}</Select.Option>
                <Select.Option value={4}>{t("deviceType.alarm")}</Select.Option>
                <Select.Option value={5}>{t("deviceType.lidar")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("DevicePage.deviceModal.description")}
              name="devicedescription"
              rules={[{ required: true, message: t("DevicePage.deviceModal.descriptionRequired") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddDeviceModal;
